import Box from '@mui/material/Box'
import Skeleton from '@mui/material/Skeleton'
import Stack from '@mui/material/Stack'

export type SkeletonTableProps = {
    rows?: number
    columns?: number
    showToolbar?: boolean
    rowHeight?: number
}

export default function SkeletonTable(props: Readonly<SkeletonTableProps>) {
    const { rows = 12, columns = 6, showToolbar = true, rowHeight = 40 } = props

    const columnWidths = Array.from({ length: columns }, (_, index) =>
        index === 0 ? '28%' : `${Math.floor(72 / Math.max(columns - 1, 1))}%`,
    )

    return (
        <Stack spacing={2} sx={{ width: '100%' }}>
            {showToolbar && (
                <Stack
                    direction="row"
                    spacing={2}
                    sx={{ alignItems: 'center', justifyContent: 'space-between' }}
                >
                    <Skeleton variant="rounded" width={280} height={40} />
                    <Stack direction="row" spacing={1}>
                        <Skeleton variant="rounded" width={110} height={36} />
                        <Skeleton variant="rounded" width={110} height={36} />
                        <Skeleton variant="circular" width={36} height={36} />
                    </Stack>
                </Stack>
            )}

            <Box
                sx={{
                    border: '1px solid',
                    borderColor: 'divider',
                    borderRadius: 1,
                    overflow: 'hidden',
                }}
            >
                <Stack
                    direction="row"
                    spacing={2}
                    sx={{
                        px: 2,
                        py: 1.5,
                        bgcolor: 'action.hover',
                        alignItems: 'center',
                    }}
                >
                    {columnWidths.map((width, index) => (
                        <Skeleton key={index} variant="text" width={width} />
                    ))}
                </Stack>

                {Array.from({ length: rows }, (_, rowIndex) => (
                    <Stack
                        key={rowIndex}
                        direction="row"
                        spacing={2}
                        sx={{
                            px: 2,
                            alignItems: 'center',
                            height: rowHeight,
                            borderTop: '1px solid',
                            borderColor: 'divider',
                        }}
                    >
                        {columnWidths.map((width, index) => (
                            <Skeleton key={index} variant="text" width={width} />
                        ))}
                    </Stack>
                ))}
            </Box>
        </Stack>
    )
}
